import React from "react"
import { ActionSuccessfulTemplate } from "./ActionSuccessfulTemplate"
import { routes } from "../../routes"
import { useI18next } from "gatsby-plugin-react-i18next"

type Props = {
  orderId: string
  countryCode: string
  slug: string
}

export const AddCardSuccessfulScreen = ({
  orderId,
  countryCode,
  slug,
}: Props) => {
  const { navigate } = useI18next()

  return (
    <ActionSuccessfulTemplate
      buttonText="Gå til kredit kort"
      buttonOnClick={() => {
        navigate(
          routes.checkout.creditCards.base({
            orderId,
            countryCode,
            slug,
          })
        )
      }}
      header="Dit kort er tilføjet"
      subtitle="Du kan nu bruge det til at betale for dine ordrer"
    />
  )
}
